<template>
  <div class="auth-error-bg">
    <div class="error-bg-text">ERROR</div>
    <div class="auth-error-content">
      <div class="auth-error-icon">
        <!-- Warning SVG icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
          <path d="M25.2 8.3L1.52502 45.6C-0.874979 49.4 1.85002 54.35 6.32502 54.35H53.675C58.175 54.35 60.9 49.4 58.475 45.6L34.8 8.3C32.575 4.775 27.425 4.775 25.2 8.3Z" fill="url(#paint0_linear_1_20)"/>
          <path d="M30 39.4C28.075 39.4 26.525 23.1 26.525 23.1C26.525 21.175 28.075 19.625 30 19.625C31.925 19.625 33.475 21.175 33.475 23.1C33.475 23.075 31.925 39.4 30 39.4Z" fill="white"/>
          <path d="M30 49.225C29.1 49.225 28.175 48.85 27.55 48.2C27.375 48.05 27.25 47.875 27.125 47.675C27 47.475 26.875 47.275 26.8 47.075C26.725 46.875 26.65 46.65 26.6 46.425C26.55 46.2 26.525 45.975 26.525 45.75C26.525 45.5 26.55 45.3 26.6 45.075C26.65 44.825 26.7 44.625 26.8 44.425C26.875 44.2 27 44.025 27.125 43.825C27.25 43.625 27.375 43.45 27.55 43.3C27.7 43.125 27.875 43 28.075 42.875C28.275 42.75 28.475 42.625 28.675 42.55C28.875 42.475 29.075 42.4 29.325 42.35C29.75 42.275 30.225 42.275 30.675 42.35C30.925 42.4 31.125 42.45 31.325 42.55C31.55 42.625 31.725 42.75 31.925 42.875C32.125 43 32.3 43.125 32.45 43.3C33.1 43.95 33.475 44.825 33.475 45.75C33.475 45.975 33.45 46.2 33.4 46.425C33.35 46.65 33.3 46.875 33.2 47.075C33.125 47.3 33 47.475 32.875 47.675C32.75 47.875 32.625 48.05 32.45 48.2C31.825 48.85 30.9 49.225 30 49.225Z" fill="white"/>
          <defs>
            <linearGradient id="paint0_linear_1_20" x1="30" y1="54.35" x2="30" y2="5.65" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F69D2E"/>
              <stop offset="1" stop-color="#F5DE0E"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="auth-error-title">
        <span class="orange">Uh-oh!</span>
        <span> We couldn’t log you in.</span>
      </div>
      <div class="auth-error-subtext">
        Something seems off with your login details.
      </div>
      <div class="auth-error-box">
        <span class="error-label">Error:</span>
        <span class="error-message">{{ $route.query.error_message }}</span>
      </div>
      <div class="auth-error-footer">
        <span class="footer-icon">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="0.75" width="30.5" height="30.5" rx="15.25" stroke="#DCDAD5" stroke-width="1.5"/>
            <path d="M19.22 11.9533L23.2667 16L19.22 20.0466" stroke="#FC6B2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.73334 16H23.1533" stroke="#FC6B2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="footer-text">Please contact your <span class="admin">admin</span> for further assistance.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthError',
};
</script>

<style scoped>
.auth-error-bg {
  min-height: 100vh;
  background: #fcfbf9;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.error-bg-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12vw;
  font-weight: 700;
  color: #eae8e4;
  opacity: 0.25;
  letter-spacing: 0.1em;
  user-select: none;
  z-index: 1;
  pointer-events: none;
}
.auth-error-content {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.auth-error-icon {
  margin-bottom: 24px;
}
.auth-error-title {
  font-size: 3.125rem;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: center;
  line-height: 1.1;
}
.auth-error-title .orange {
  color: #ff7300;
  margin-right: 6px;
}
.auth-error-subtext {
  color: #b3b3b3;
  font-size: 1.5rem;
  margin-bottom: 32px;
  text-align: center;
  font-weight: 700;
}
.auth-error-box {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px 0 rgba(44, 39, 56, 0.06);
  padding: 28px 32px;
  display: flex;
  align-items: flex-start;
  font-size: 1.125rem;
  margin-bottom: 36px;
  width: 100%;
  max-width: 540px;
  min-height: 60px;
}
.error-label {
  color: #e74c3c;
  font-weight: 700;
  margin-right: 12px;
  min-width: 60px;
  display: inline-block;
}
.error-message {
  color: #222;
  font-weight: 700;
}
.auth-error-footer {
  display: flex;
  align-items: center;
  color: #b3b3b3;
  font-size: 1rem;
  margin-top: 8px;
  gap: 8px;
}
.footer-icon {
  display: flex;
  align-items: center;
  margin-right: 4px;
}
.footer-text .admin {
  color: #ff7300;
  font-weight: 500;
}
@media (max-width: 600px) {
  .auth-error-content {
    max-width: 95vw;
    padding: 0 4vw;
  }
  .auth-error-box {
    padding: 18px 8px;
    font-size: 1rem;
  }
  .auth-error-title {
    font-size: 1.5rem;
  }
  .error-bg-text {
    font-size: 18vw;
  }
}
</style>